import { createRoutine } from "../utils/routine.utils";
export var getInsurance = createRoutine("INSURANCE_GET");
export var resetInsuranceProposal = createRoutine("RESET_INSURANCE_PROPOSAL");
